import {DateTime} from "luxon";
import {useCallback, useReducer} from "react";

export interface DateRangeState {
  start: DateTime
  finish: DateTime
}

interface Action {
  type: "onChange",
  payload: {
    start: DateTime
    finish: DateTime
  }
}

function reducer(state: DateRangeState, action: Action): DateRangeState {
  if (action.type === "onChange") {
    return action.payload
  }
  return {start: DateTime.local(), finish: DateTime.local()}
}

export function useDateRangeState() {
  const [state, dispatch] = useReducer(reducer, {start: DateTime.local(), finish: DateTime.local()})

  const onChange = useCallback( (start: DateTime, finish: DateTime) => {
    dispatch({type: "onChange", payload: {start, finish}})
  }, [])


  return {...state, onChange}
}
